export const linkTypes = {
  internal: 'internal',
  external: 'external'
}
